import React from 'react'
import BaseIcon from 'react-icon-base'

const MU = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 6 4" {...props}>
    <title>Flag of Mauritius</title>
    <rect fill="#00A551" width="6" height="4" />
    <rect fill="#FFD500" width="6" height="3" />
    <rect fill="#1A206D" width="6" height="2" />
    <rect fill="#EA2839" width="6" height="1" />
  </BaseIcon>
)

export default MU
